import { Accordion, AccordionSummary, AccordionDetails, Typography, ListItem, Box, Divider, Paper } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomShaped from '../styled/CustomShaped';
import { useSelector } from 'react-redux';
import { selectIfThreadHistoryLoaded, selectThreadHistory } from '../../store/slices/threadsSlice';
import { Link } from 'react-router-dom';
import { SCROLL_BAR_STYLE_PROPS } from '../../constants/ScrollbarProps';
import React, { useMemo } from 'react';
import { groupByField } from '../../utils/ArrayUtility';
import { APP_ROUTES } from '../../constants/AppRoutes';

function SavedForLater({ bookmarks }: { bookmarks: any[] }) {
    const groupedBookmarks = useMemo(
        () => groupByField(bookmarks, 'created_at'),
        [bookmarks]);

    const history = useSelector(selectThreadHistory);
    const historyLoaded = useSelector(selectIfThreadHistoryLoaded);

    const getQueryForTheBookedResponse = (thread_id: string, entry_id: string) => {
        if (history.length > 0) {
            const thread = history.filter((s: any) => s.thread_id === thread_id)[0];
            if (thread === undefined) return;
            const entry = thread.entries.filter((s: any) => s.entry_id === entry_id)[0];
            const index = thread.entries.indexOf(entry);

            return thread.entries[index - 1].data.content.text;
        }
        return null;
    }

    return (
        <>
            <Accordion defaultExpanded={true}
                TransitionProps={{ timeout: 200 }}
                elevation={0}
                sx={{
                    marginTop: 2,
                    position: 'relative',
                    background: 'transparent',
                    '& .MuiAccordion-heading .MuiAccordionSummary-root': {
                        marginLeft: '15.5%',
                        lineHeight: 1,
                    },
                    '& .MuiAccordionSummary-contentGutters': {
                        margin: '0 !important',
                    },
                    '&.Mui-expanded .MuiAccordionSummary-root': {
                        borderBottom: '0px !important',
                    },
                    '&.MuiAccordion-root::before': {
                        display: 'none'
                    }

                }}>
                <AccordionSummary
                    aria-controls="panel1-content"
                    id="panel1-header"
                    expandIcon={<ExpandMoreIcon htmlColor='var(--text-primary)' />}
                    sx={{
                        display: 'flex',
                        width: 'max-content',
                        padding: 0,
                        borderBottom: '2px solid  black !important',
                        transition: 'margin 100ms ease-in-out'
                    }}>
                    <Typography variant='h6' component={'div'}>
                        Saved
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <CustomShaped borderSize='short' bgcolor='#03F0FF1A'>
                        <Box sx={{
                            minHeight: '12.5vh',
                            maxHeight: '25vh',
                            overflow: 'scroll',
                            boxSizing: 'border-box',
                            paddingY: 2,
                            overflowX: 'hidden',
                            ...SCROLL_BAR_STYLE_PROPS,
                        }}>
                            {(bookmarks.length === 0 || historyLoaded === false) && <Typography>No saved items.</Typography>}
                            {
                                (historyLoaded && history.length > 0) && bookmarks.length > 0 &&
                                Object.entries(groupedBookmarks)
                                    .map(([day, bookmarks]: [day: string, chat: any], index: number) => {
                                        if (bookmarks.length === 0) return <React.Fragment key={index}></React.Fragment>
                                        return <Paper
                                            elevation={0}
                                            key={index}
                                            sx={{
                                                background: 'transparent',
                                                marginBottom: 2,
                                                '&:last-of-type': {
                                                    marginBottom: 0
                                                }
                                            }}>
                                            <Typography variant="subtitle1" marginBottom={1} component={'div'} sx={{
                                                marginLeft: 3,
                                            }}>
                                                {day}
                                            </Typography>
                                            {bookmarks.map((eachBookmark: any, eIndex: number) => {
                                                return (
                                                    <Box key={eIndex} sx={{
                                                        paddingLeft: 3,
                                                        transition: 'background 200ms ease-in-out',
                                                        '&:hover': {
                                                            background: '#00FFF233',
                                                        }
                                                    }}>
                                                        <ListItem
                                                            component={Link}
                                                            to={`${APP_ROUTES.ASK_GUARDIAN}/${encodeURIComponent(eachBookmark.thread_id)}?entry_id=${eachBookmark.entry_id}`}
                                                            replace={true}
                                                            sx={{
                                                                p: 0,
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                rowGap: 0.5,
                                                                alignItems: 'start',
                                                                textWrap: 'balance',
                                                                color: 'var(--text-dark)',
                                                                fontWeight: 400,
                                                                '&:hover': {
                                                                    color: 'var(--text-dark)',
                                                                }
                                                            }}>
                                                            <Typography variant="body1" fontStyle={'italic'} fontSize={'1rem'} lineHeight={1.25}>
                                                                {getQueryForTheBookedResponse(eachBookmark.thread_id, eachBookmark.entry_id)}
                                                            </Typography>
                                                        </ListItem>
                                                        {eIndex + 1 < bookmarks.length && <Divider sx={{ width: '100%', background: '#3E3E3E', my: 1 }}></Divider>}
                                                    </Box>
                                                )
                                            })}
                                        </Paper>
                                    })
                            }
                        </Box>
                    </CustomShaped>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default SavedForLater